module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAYAAABPwleqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACZSURBVHgB7VTdCYYwDGw++v45QkdwAx1BN3ADcRIdyRG6gW6gThAvoiL+YIuPenBcSbikhaSkAGYOITEYqHu0YE1ErRgN2LEfGqmiNx0L0Dp0zsFEmupN0OIq9Z0Tpmw5/9QDfOaXmzFJ5TzHsbcZMDs9QF8lMOeprCrUuphlNc0u35/E/utJ3sT+mPaZ5gIZJFJuGMBKfpIR/CKa2lHYpY0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/icon-phone.png
// module id = LyPF
// module chunks = 0